import type { ReactNode } from 'react';

import './PhaseHeader.scss';

interface IPhaseHeaderProps {
  number: string;
  title: string;
  status?: ReactNode;
  className?: string;
}

const PhaseHeader = ({ number, title, status, className }: IPhaseHeaderProps) => (
  <header className={`phase-header ${className ?? ''}`}>
    <span className="phase-header__number">{number}</span>
    <span className="phase-header__title">{title}</span>
    {status && <span className="phase-header__status">{status}</span>}
  </header>
);

export default PhaseHeader;
